<style lang="less" scoped>
tr, td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr .td {float: left;}
.tr {width: 100%;height: 50px;}
.table {border-collapse: collapse;width: 100%;}
.select1 .el-input__inner {width: 150px;}
.ziduanKey .el-input__inner {width: 340px;}
.level .el-input__inner {width: 150px;}
.sort .el-input__inner {width: 150px;}
.date-picker.el-input {width: 150px;}
.date-picker.el-input {width: 150px;}
.count .el-input__inner {width: 50px;}
.el-checkbox__inner {border-radius: 50%;}
.btnbox {width: 100%;text-align: left;border-bottom: 1px solid #e7e7eb;height: 60px;}
.btnbox .elbtn {margin-top: 10px;margin-left: 15px;}
.recycling_box .delete {margin-left: 40px;}
.btnbox .level {margin-left: 10px;}
.el-form-item {float: left;margin-bottom: 0px;}
.el-pagination {text-align: center;}
.el-form table {width: 100%;}
.tr1 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.tr2 td .el-form-item /deep/.el-form-item__content {margin-left: 10px;}
.select1 /deep/ .el-input__inner {width: 150px;}
.ziduanKey /deep/ .el-input__inner {width: 340px;}
.level /deep/ .el-input__inner {width: 150px;}
.sort /deep/ .el-input__inner {width: 150px;}
.count /deep/ .el-input__inner {width: 50px;}
.pagination{margin-bottom: 40px;margin-top: 40px;}
.input1{width: 150px;margin-right: 3px;}
</style>

<template>
  <div class="second" id="second">
    <div class="dmkclb—_box second">
      <el-form ref="form" :model="form">
        <table class="dmkclb">
          <tr class="tr tr1">
            <td>
              <el-form-item>
                <div class="td td1">
                  <el-select clearable v-model="form.ziduan" placeholder="请选择" class="select select1">
                    <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.company" placeholder="请输入关键词" class="input ziduanKey"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-select clearable v-model="form.level" placeholder="级别" class="select level">
                    <el-option v-for="item in level_data" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-select clearable v-model="form.sort" placeholder="结果排序方式" class="select sort">
                    <el-option v-for="item in options3" :key="item.value" :label="item.label" :value="item.description"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.count" placeholder="20" class="input count"></el-input>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-button class="elbtn search" @click="search()">搜索</el-button>
                  <el-button class="elbtn reset" @click="cancelfnBtn()">重置</el-button>
                </div>
              </el-form-item>
            </td>
          </tr>
          <tr class="tr tr2">
            <td>
              <el-form-item>
                <div class="td td1">
                  <span>注册资本</span>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-input v-model="form.littlenum" placeholder="" class="input1"></el-input>
                  <span style="font-size: 18px;text-align: center;">~</span>
                  <el-input v-model="form.bignum" placeholder="" class="input1"></el-input>万
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-select clearable v-model="form.type" placeholder="选择类型" class="select select1">
                    <el-option v-for="item in options5" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-select clearable v-model="form.catid" placeholder="请选择行业" class="select select1">
                    <el-option v-for="item in options8" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-select clearable v-model="form.size" placeholder="公司规模" class="select select1">
                    <el-option v-for="item in options9" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item>
                <div class="td">
                  <el-button type="success" v-if="parms === 'Qyzsgl'" @click="addfn()">添加</el-button>
                </div>
              </el-form-item>
            </td>
          </tr>
        </table>
      </el-form>
      <div class="el-tablebox">
        <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" stripe border :cell-style="{ textAlign: 'center' }" :header-cell-style="{ background: '#F5F5F5', color: '#606266', textAlign: 'center', }">
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="level" label="级别" width="50"></el-table-column>
          <el-table-column prop="company" label="公司名称" width="250"></el-table-column>
          <el-table-column prop="type" label="类型"></el-table-column>
          <el-table-column prop="mode" label="经营模式" > </el-table-column>
          <el-table-column prop="size" label="公司规模"></el-table-column>
          <el-table-column prop="capital" label="注册资金"></el-table-column>
          <el-table-column prop="hits" label="人气"></el-table-column>
          <el-table-column label="审核" width="150">
            <template slot-scope="scope">{{ scope.row.examine | examine_data() }}</template>
          </el-table-column>
          <el-table-column prop="id" label="操作" width="350">
            <template slot-scope="scope">
              <el-button type="success" v-if="show2" @click="look(scope.row)">发布</el-button>
              <el-button type="primary" v-if="show1" @click="look(scope.row)">审核</el-button>
              <el-button type="warning"  @click="updatafn(scope.row)">修改</el-button>
              <el-button type="danger" @click="deletefn(11, 26,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btnbox">
        <el-button type="danger" class="elbtn delete" @click="deletesfn(11, 26)">批量删除</el-button>
      </div>
    </div>
    <!-- 分页 -->
    <div class="block">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import filters from '../../method/filter'
import method from '../../method/methods'
import {mapState} from 'vuex'
export default {
  mixins: [filters, method],
  data()
  {
    return {
      form: {
        ziduan: 'company',
        company: '',
        level: '',
        sort: '',
        count: 20,
        littlenum: '',
        bignum: '',
        type: '',
        catid: '',
        size: '',
        ssgj: ''
      },
      options1: [
        { value: 'company', label: '公司名称', key: 'company' },
        { value: 'address', label: '公司地址', key: 'address' },
        { value: 'business', label: '主要经营范围', key: 'business' }
      ],
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      options3: [
        { value: '选项5', label: '人气降序', description: 'hits DESC' },
        { value: '选项6', label: '人气升序', description: 'hits ASC' },
        { value: '选项9', label: '信息ID降序', description: 'id DESC' },
        { value: '选项10', label: '信息ID升序', description: 'id ASC' }
      ],
      //分类数据
      options5: [
        { value: '不限', label: '不限' },
        { value: '企业单位', label: '企业单位' },
        { value: '事业单位或社会团体', label: '事业单位或社会团体' },
        { value: '个体经营', label: '个体经营' },
        { value: '其他', label: '其他' }
      ],
      options8: [
        { value: 0, label: '不限' },
        { value: 84, label: '设备药剂企业' },
        { value: 82, label: '矿山企业' },
        { value: 81, label: '地勘单位' },
        { value: 85, label: '珠宝企业' },
        { value: 87, label: '投融资企业' },
        { value: 88, label: '贸易企业' },
        { value: 83, label: '科研企业' },
        { value: 89, label: '其他企业' }
      ],
      options9: [
        { value: '1-49人', label: '1-49人' },
        { value: '50-99人', label: '50-99人' },
        { value: '100-499人', label: '100-499人' },
        { value: '500-999人', label: '500-999人' },
        { value: '1000-3000人', label: '1000-3000人' },
        { value: '3000-5000人', label: '3000-5000人' },
        { value: '5000-10000人', label: '5000-10000人' },
        { value: '10000以上', label: '10000以上' }
      ],
      pageSize: 20,
      currentPage: 1,
      countSum: null,
      //列表数据
      tableData: [],
      show1: false,
      show2: false,
      parms: ''
    }
  },
  // 根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID,
      IsLb: state => state.IsLb
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    },
    IsLb:
    {
      handler(nval, oval)
      {
        if (nval === '1')
          this.getList()
        this.$store.commit('onIsLb', '0')
      },
      deep: true,
      immediate: true
    }
  },
  created()
  {
    this.getList()
    this.urlpath = window.location.href
    this.parms = this.urlpath.substring(this.urlpath.lastIndexOf('/') + 1)
    let userInfo = JSON.parse(localStorage.getItem('userMsg')).role
    if (userInfo.indexOf(1) !== -1)
    {
      this.show1 = true
      this.show2 = false
    }
    if (userInfo.indexOf(6) !== -1)
    {
      this.show2 = true
      this.show1 = false
    }
    if (userInfo.indexOf(0) !== -1 || (userInfo.indexOf(1) !== -1 && userInfo.indexOf(6) !== -1))
    {
      this.show2 = true
      this.show1 = true
    }
    if (userInfo.indexOf(8) !== -1)
    {
      this.show1 = false
      this.show2 = false
    }
  },
  methods: {
    getList()
    {
      let userInfo = JSON.parse(localStorage.getItem('userMsg')).role[0]
      let count = this.form.count
      let littlenum = this.form.littlenum
      let bignum = this.form.bignum
      let ziduan = this.form.ziduan
      let currentPage = this.currentPage
      let exp = ''
      let reorder = ''
      for (let e in this.form)
      {
        let item = this.form[e]
        if (item && e === 'company')
          exp += `${ziduan} like '%${item}%' and `
        if (item && e === 'level')
          exp += `level = ${item} and `
        if (item && e === 'littlenum')
          exp += `capital >= ${littlenum} and `
        if (item && e === 'bignum')
          exp += `capital <= ${bignum} and `
        if (item && e === 'type' && item !== '不限')
          exp += `type = '${item}' and `
        if (item && e === 'catid' && item !== '不限')
          exp += `catid like '%${item}%' and `
        if (item && e === 'size' && item !== '不限')
          exp += `size = '${item}' and `
        if (item && e === 'sort')
          reorder = `${item}`
      }
      reorder = reorder ? reorder : `id DESC `
      if (userInfo === 1)
        exp = exp ? `${exp}id != 0` : 'id>0 and examine = 1'
      else
        exp = exp ? `${exp}id != 0` : 'id>0'
      this.find(11, 26, exp, 0, currentPage, count, reorder).then((ret) =>
      {
        this.countSum = ret[0].total
        this.tableData = []
        ret[0].data.forEach((item) =>
        {
          this.tableData.push({
            id: item.id,
            company: item.company,
            level: item.level,
            type: item.type,
            mode: item.mode,
            size: item.size,
            capital: item.capital,
            regunit: item.regunit,
            hits: item.hits,
            examine: item.examine
          })
        })
      })
    },
    //点击修改
    updatafn(row)
    {
      this.$router.push({path: '/QyzsUpdate', query: {id: row.id}})
    },
    //点击查看
    look(row)
    {
      this.$router.push({path: '/QyzsLook', query: {id: row.id}})
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) =>
      {
        temp.push(item.id)
      })
      this.multipleSelection = temp
    },
    handleSizeChange()
    {
      this.pageSize = this.form.count
    },
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    /**
     * 彻底删除--单
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletefn(major, minor, row)
    {
      let that = this
      window.public.deletefn(major, minor, row, that)
    },
    /**
     * 彻底删除——多
     * 获取下拉框列表
     * @param {String} major  //主类型
     * @param {String} minor  //子类型
     */
    deletesfn(major, minor)
    {
      let that = this
      window.public.deletesfn(major, minor, that)
    },
    //子组件调用新增添加Tabs
    addfn()
    {
      this.$emit('addTab')
    },
    //————列表页的公共方法——
    //搜索
    search()
    {
      this.getList()
      this.handleSizeChange(this.form.count)
    },
    //重置搜索条件
    cancelfnBtn()
    {
      let str = 'count'
      let that = this
      window.public.cancelfnBtn(str, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/assembly/xsyz/QyzsLb.vue